var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0-Base/icons/chevron-down",
    transform: "translate(0.000000, -5.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82480128,0.413276181 L18.1238133,11.0744746 C18.3751856,11.3324968 18.5,11.6669494 18.5,12 C18.5,12.3330651 18.3751856,12.6677966 18.1238133,12.9255398 L7.82480128,23.5867383 C7.31001943,24.1219739 6.45572454,24.13938 5.91799349,23.6268335 C5.37660632,23.1177627 5.35900069,22.2667078 5.87756804,21.7350426 L15.327235,11.949725 L5.87918236,2.26489929 C5.36063189,1.73490774 5.37823752,0.882458174 5.91960781,0.373108401 C6.45741198,-0.139588688 7.31294432,-0.121736341 7.82480128,0.413276181 Z",
    id: "Path",
    transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.86276445c2ea9eb6e2109511de6e2e44.svg";
export { ForwardRef as ReactComponent };